module.exports = "/_next/static/images/caa3b44fb0cf1c53bba4c5222066ba93-roxinho-basicos-flutuantes-lg@1x.png";